module.exports = __webpack_public_path__ + "img/send.c77eebff.svg";